export default __webpack_public_path__ + "static/media/learose4-1440w.1d036f19.webp";